export default Object.freeze([
	{ label: 'Create declarations from order items', value: 'orderitems' },
	{ label: 'Use pre-defined values', value: 'static' },
	{ label: 'Leave blank (enter manually)', value: 'blank' },
]);
